import React, { useState, useEffect } from 'react'
import { isEmptyOrNil } from 'libs/empty'
import { makeStyles } from '@material-ui/styles'
import { twMerge } from 'tailwind-merge'
import PrimaryTooltip from 'app/componentV4/Tooltip/PrimaryTooltip'
import CameraAltOutlinedIcon from '@material-ui/icons/CameraAltOutlined'
import MessagespringLoading from 'app/componentV4/Loader/MessagespringLoading'
import Assets from 'app/configs/assetConfigs'
import { resizeAvatar_250 } from 'commons/resizeImage'

const useStyles = makeStyles((theme) => ({
  black: {
    backgroundColor: '#071E3D',
  },
  navy: {
    backgroundColor: '#1F4287',
  },
  cyan: {
    backgroundColor: '#0E9CBC',
  },
  purple: {
    backgroundColor: '#7045AF',
  },
  magenta: {
    backgroundColor: '#E14594',
  },
  orange: {
    backgroundColor: '#E18745',
  },
}))

const bgColorSet = ['black', 'navy', 'cyan', 'purple', 'magenta', 'orange']

const ImageProfileOrCharacter = ({
  className,
  src,
  placeHolder,
  subscriberId,
  isLoading = false,
  onImageSelected,
  isEditImage = false,
}) => {
  const avatarClasses = useStyles()
  const [isFailed, setIsFailed] = useState(false)

  useEffect(() => {
    setIsFailed(false)
  }, [src])

  return (
    <div className="flex w-full h-full relative">
      {isLoading ? (
        <div className="flex m-auto">
          <div className="flex justify-center m-auto">
            <div>
              <MessagespringLoading size={36} />
            </div>
          </div>
        </div>
      ) : (
        <>
          {isFailed || isEmptyOrNil(src) ? (
            <div
              className={twMerge(
                className,
                avatarClasses[getBgClassName(subscriberId)],
                'w-full h-full rounded-8 flex justify-center items-center font-bold text-white',
              )}
            >
              {placeHolder}
            </div>
          ) : (
            <PrimaryTooltip
              title={
                <img
                  src={src}
                  alt="Tooltip Preview"
                  className="w-256 h-auto"
                  onError={(e) => {
                    e.target.onerror = null
                    e.target.src = Assets.personSilhouetteImage
                  }}
                />
              }
              arrow
              placement="bottom-start"
            >
              <div className="w-full h-full flex justify-center items-center font-bold text-white overflow-hidden">
                <img
                  src={resizeAvatar_250(src)}
                  className="w-full h-full object-cover rounded-8"
                  alt="Subscriber profile"
                  onError={(e) => {
                    e.target.onerror = null
                    e.target.src = Assets.personSilhouetteImage
                  }}
                />
              </div>
            </PrimaryTooltip>
          )}
          <input
            type="file"
            accept="image/*"
            id="fileInput"
            className="hidden"
            onChange={onImageSelected}
          />
          {isEditImage && (
            <label htmlFor="fileInput">
              <div className="absolute bottom-0 right-0 p-1 m-1 text-white bg-primary-350 rounded-4 flex items-center justify-center cursor-pointer">
                <CameraAltOutlinedIcon className="text-primary-400 text-14" />
              </div>
            </label>
          )}
        </>
      )}
    </div>
  )
}

const getBgClassName = (subscriberId) => {
  return parseInt(subscriberId)
    ? bgColorSet[parseInt(subscriberId) % bgColorSet.length]
    : bgColorSet[0]
}

export default React.memo(ImageProfileOrCharacter)
